import { createRootRoute, ErrorComponent, Outlet } from "@tanstack/react-router";
import { NotFoundPage } from "@/components/ErrorPages/NotFoundPage";
import { ThemeProvider } from "@/components/theme-provider";

export const Route = createRootRoute({
  component: () => (
    <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
      <Outlet />
    </ThemeProvider>
  ),
  notFoundComponent: () => <NotFoundPage />,
  errorComponent: ({ error }) => {
    console.error("Root route error:", error);
    return <ErrorComponent error={error} />;
  },
});
